import NotFound from "./NotFound";
import { useParams, Link } from "react-router-dom";
import { CalendarDays, Clock } from "lucide-react";
import SubLayout from "@/components/site/SubLayout";
import Breadcrumbs from "@/components/site/Breadcrumbs";
import CtaBlock from "@/components/site/CtaBlock";
import Seo from "@/seo/Seo";
import { breadcrumbSchema, articleSchema, localBusinessSchema } from "@/seo/schemas";
import { POSTS, postBySlug } from "@/data/blog";

export default function BlogPost() {
  const { slug } = useParams();
  const post = postBySlug(slug);
  if (!post) return <NotFound />;

  const path = `/blog/${post.slug}`;
  const title = `${post.title} | The VIN Verifier CA`;
  const description = post.excerpt;
  const related = POSTS.filter((p) => p.slug !== slug).slice(0, 3);
  const schema = [breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }, { name: post.title, path }]), articleSchema({ title: post.title, description, path, date: post.date }), localBusinessSchema()];

  return (
    <SubLayout>
      <Seo title={title} description={description} path={path} schema={schema} />
      <article className="max-w-3xl mx-auto px-5 lg:px-8 py-10 lg:py-14">
        <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }, { name: post.title, path }]} />
        <h1 className="font-display font-extrabold text-ink tracking-tight text-3xl sm:text-4xl mt-5 leading-[1.1]">{post.title}</h1>
        <div className="flex items-center gap-4 text-sm text-slate2 mt-4">
          <span className="flex items-center gap-1.5"><CalendarDays size={14} /> {new Date(post.date).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</span>
          <span className="flex items-center gap-1.5"><Clock size={14} /> {post.read} read</span>
        </div>

        <div className="mt-8 space-y-8">
          {post.body.map((sec) => (
            <section key={sec.h2}>
              <h2 className="font-display font-bold text-ink text-xl sm:text-2xl">{sec.h2}</h2>
              <div className="mt-3 space-y-4">
                {sec.p.map((para, i) => (<p key={i} className="text-slate2 text-base leading-relaxed">{para}</p>))}
              </div>
            </section>
          ))}
        </div>

        <div className="mt-14"><CtaBlock heading="Need a VIN verification?" sub="Licensed, mobile & same-day across Orange County and Los Angeles." /></div>

        <div className="mt-14">
          <h2 className="font-display font-bold text-ink text-xl">Related Guides</h2>
          <div className="grid sm:grid-cols-3 gap-4 mt-4">
            {related.map((r) => (
              <Link key={r.slug} to={`/blog/${r.slug}`} className="card-soft p-5">
                <h3 className="font-display font-semibold text-ink text-sm leading-snug">{r.title}</h3>
                <span className="text-brand text-xs font-semibold mt-2 inline-block">Read →</span>
              </Link>
            ))}
          </div>
        </div>
      </article>
    </SubLayout>
  );
}
